import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgChatText = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.391 8.875 8.663 12.4m6.674-3.525L13.61 12.4M10.998 18.245v2.242c0 .312.287.546.59.467 4.2-1.09 7.899-4.815 8.373-9.246.055-.52.046-1.025.008-1.544-.42-4.009-3.828-7.134-7.97-7.134-4.14 0-7.547 3.125-7.968 7.134a8 8 0 0 0 .012 1.544c.416 3.559 3.133 6.348 6.955 6.537"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgChatText);
export default ForwardRef;
